// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"8":"9a600b0e","79":"21e0b095","226":"2eb18b04"}[chunkId] + ".js";
};